<template>
  <div style="padding-bottom:100px">
    <b-breadcrumb :items="breadCrumbs" />

    <div class="add_shipment_button_container">
      <b-button
        variant="secondary"
        @click="addShipment"
        :disabled="shipments.length >= orderItems.length"
        >Add Shipment</b-button
      >
    </div>

    <b-row>
      <b-col
        md="3"
        sm="6"
        v-for="(shipment, index) in shipments"
        :key="shipment.id"
      >
        <Shipment
          :shipment="shipment"
          :index="index + 1"
          @unallocate="unallocate"
          @delete="deleteShipment"
          @scan="scan"
        />
      </b-col>
      <b-col>
        <b-button class="float-right" variant="success" @click="submit"
          >Submit</b-button
        >
      </b-col>
      <div class="unallocated">
        <div v-if="unallocated.length">
          <h5>Unallocated Items</h5>
          <div v-for="unallocatedItem in unallocated" :key="unallocatedItem.id">
            {{ unallocatedItem.name }} ({{ unallocatedItem.model }})
          </div>
        </div>
        <div v-else>Nothing left to allocate</div>
      </div>
    </b-row>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";
import Shipment from "../components/shipping/Shipment";
export default {
  name: "shipping-allocation",
  components: {
    Shipment
  },
  data() {
    return {
      shipments: [],
      unallocated: [],
      order: null,
      orderItems: [],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Shipping", to: { name: "shipping" } },
        { text: "Shipping Allocation", active: true }
      ]
    };
  },
  mounted() {
    this.fetchOrder();
  },
  methods: {
    scan(data) {
      const scannedItem = this.unallocated.find(
        item => item.model === data.model
      );
      this.unallocated = this.unallocated.filter(
        item => item.model !== data.model
      );
      if (!scannedItem) {
        this.$swal(
          "Error!",
          "No item with this model found in unallocated list",
          "warning"
        );
      } else {
        const shipment = this.shipments.find(
          shipment => shipment.id === data.shipment_id
        );

        const newShipment = {
          ...shipment,
          items: [...shipment.items, scannedItem]
        };

        this.shipments = this.shipments.map(shipment =>
          shipment.id !== data.shipment_id ? shipment : newShipment
        );
      }
    },
    deleteShipment(shipmentId) {
      const shipment = this.shipments.find(
        shipment => shipment.id === shipmentId
      );

      this.unallocated.push(...shipment.items);
      this.shipments = this.shipments.filter(
        shipment => shipment.id !== shipmentId
      );
    },
    addShipment() {
      this.shipments.push({
        items: [],
        id: uuidv4()
      });
    },
    unallocate(data) {
      const shipment = this.shipments.find(
        shipment => shipment.id === data.shipment_id
      );

      const unAllocatedItem = shipment.items.find(
        item => item.id === data.item_id
      );

      if (shipment.items.length === 1) {
        this.shipments = this.shipments.filter(
          shipment => shipment.id !== data.shipment_id
        );
      } else {
        const newShipment = {
          ...shipment,
          items: shipment.items.filter(item => item.id !== data.item_id)
        };
        this.shipments = this.shipments.map(shipment =>
          shipment.id !== data.shipment_id ? shipment : newShipment
        );
      }

      this.unallocated.push(unAllocatedItem);
    },
    fetchOrder() {
      let loader = this.$loading.show();
      this.$http
        .get(
          this.APIURL + this.BRAND + "/order-picking/" + this.$route.params.id
        )
        .then(response => {
          loader.hide();
          this.order = response.data;
          this.setShipments();
        });
    },
    setShipments() {
      for (let i = 0; i < this.order.items.length; i++) {
        const item = this.order.items[i];
        if (item.quantity > 1) {
          for (let j = 1; j <= item.quantity; j++) {
            const itemClone = JSON.parse(JSON.stringify(item));
            itemClone.quantity = 1;
            this.orderItems.push(itemClone);
          }
        } else {
          this.orderItems.push(item);
        }
      }

      this.orderItems.forEach(item => {
        item.id = uuidv4();
        this.shipments.push({
          items: [item],
          id: uuidv4()
        });
      });
    },
    submit() {
      let loader = this.$loading.show();
      this.$http
        .post(this.APIURL + this.BRAND + "/shipping/" + this.$route.params.id, {
          shipments: this.shipments
        })
        .then(response => {
          loader.hide();
          const success = response.data.status === "1";
          this.$swal({
            title: success ? "Success!" : "Failed!",
            showConfirmButton: true,
            html: `<div>${response.data.shipping.message}</div>`,
            type: success ? "success" : "error",
            onClose: () => {
              loader.hide();
              if (success) {
                this.$router.push({ name: "shipping" });
              }
            }
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.unallocated {
  position: fixed;
  bottom: 0px;
  padding: 15px;
  height: auto;
  border-top: 1px solid #ccc;
  width: 100%;
  background-color: #eee;
}
.add_shipment_button_container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}
</style>
